import Enumeration from 'Lib/utilities/Enumeration';

const ProrateMethodTypes = new Enumeration([
    { id: 1, key: 'ActualDays', name: 'Actual Days in Month' },
    { id: 2, key: 'ThirtyDays', name: '30 Day Month' },
    { id: 3, key: 'Annual', name: 'Annual (actual days)' }
]);

export default ProrateMethodTypes;
